<template>

<Scene>
  <Box :position="[0, 0, 5]"></Box>
</Scene>

</template>

<script>
import { Entity, Scene, Box } from 'vue-babylonjs';
export default {
  mixins: [Entity],
  components: { Scene, Box },
};
</script>
